import { render, staticRenderFns } from "./TATManagementTable.vue?vue&type=template&id=cc05c298"
import script from "./TATManagementTable.vue?vue&type=script&lang=js"
export * from "./TATManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports